import React from 'react';
import type { SingleValueProps } from 'react-select';
import { components } from 'react-select';
import type { SelectOptionType } from './SelectOption';
import SelectOptionContent from './SelectOptionContent';

interface SelectValueProps<Value, IsMulti extends boolean = false>
  extends SingleValueProps<SelectOptionType<Value>, IsMulti> {
  data: SelectOptionType<Value>;
}

const SelectValue = <Value, IsMulti extends boolean = false>(
  props: SelectValueProps<Value, IsMulti>,
) => (
  <components.SingleValue {...props}>
    <SelectOptionContent {...props.data} />
  </components.SingleValue>
);

export default SelectValue;
